<template>
  <div class="home">
    <!-- Banner轮播 -->
    <div class="index_banner target action">
      <div class="flicker-example flickerplate animate-transition-slide flicker-theme-light">
        <div class="dot-navigation center">
          <ul>
            <li v-for="(slide, index) in slides" :key="index" @click="goToSlide(index)">
              <div class="dot" :class="{ active: currentIndex === index }"></div>
            </li>
          </ul>
        </div>
        <div class="arrow-navigation left" :class="{ hover: leftHover }" @click="prevSlide" @mouseover="leftHover = true" @mouseout="leftHover = false">
          <div class="arrow"></div>
        </div>
        <div class="arrow-navigation right" :class="{ hover: rightHover }" @click="nextSlide" @mouseover="rightHover = true" @mouseout="rightHover = false">
          <div class="arrow"></div>
        </div>
        <ul class="flicks" :style="{ left: '-' + (currentIndex * 100) + '%' }">
          <li 
            v-for="(slide, index) in slides" 
            :key="index"
            class="banner1"
            :style="{ 
              backgroundImage: 'url(' + slide.bgImage + ')',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover'
            }"
          >
            <div class="flick-inner">
              <div class="flick-content">
                <h1>
                  <c>{{ slide.title }}</c>
                  <f>{{ slide.subtitle }}</f>
                  <g>&nbsp;</g>
                  <router-link to="/">了解我们 +</router-link>
                </h1>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 关于我们 -->
    <div class="index_about">
      <div class="index_about_two target action">
        <dl>
          <dd>
            <h1><img :src="require('@/assets/images/index_about_two_ino1.jpg')"></h1>
            <h2>核心优势</h2>
            <h4><router-link to="/about/list?menu=核心优势&type=2">了解更多</router-link></h4>
          </dd>
          <dd>
            <h1><img :src="require('@/assets/images/index_about_two_ino4.jpg')"></h1>
            <h2>公司概况</h2>
            <h4><router-link to="/about">了解更多</router-link></h4>
          </dd>
        </dl>
      </div>
      <div class="index_about_one">
        <div class="i-a-o-right target action">
          <span></span>
          <h3>华合半导体&nbsp;•&nbsp;全球化合物芯片领域的先行者</h3>
          <span></span>
          <h4>【宗旨】打造化合物半导体领域的核心芯片<br>
            【理念】与客户共赢共进，做值得信赖的合作伙伴</h4>
          <h5>
            <a href="http://oss.huaheic.com/vd/indexvideo.mp4" target="_blank"><img :src="require('@/assets/images/i-a-o-right1.jpg')"></a>
            <a href="http://oss.huaheic.com/vd/indexvideo.mp4" target="_blank"><img :src="require('@/assets/images/i-a-o-right2.jpg')"></a>
            <a href="http://oss.huaheic.com/vd/indexvideo.mp4" target="_blank"><img :src="require('@/assets/images/i-a-o-right3.jpg')"></a>
          </h5>
        </div>
      </div>
    </div>

    <!-- 服务介绍 -->
    <div class="index_pro nxa-box  " style="width: 100%;">
      <router-link class="target action" v-for="(service, index) in services" :key="index" :to="'/services/products?menu=' + service.title + '&type=' + service.type">
        <img :src="service.icon">
        <dt>
          <span>{{ service.title }}</span>
          <font>{{ service.desc }}</font>
          <strong></strong>
        </dt>
      </router-link>
    </div>

    <!-- 产品展示 -->
    <div class="mlu target action">
      <dd>
        <span>GaAs/GaN系列功放芯片</span>
        <font>GaAs/GaN功放芯片是华合半导体推出的全系列功放芯片产品，为雷达通信、仪器仪表、基站、卫星等终端提供强大且极具性价比的IP服务能力支撑。</font>
        <router-link to="/services/products?menu=GaAs/GaN系列功放芯片&type=10">探索更多</router-link>
      </dd>
      <img :src="require('@/assets/images/mlu100.jpg')">
    </div>

    <!-- 新闻中心 -->
    <div class="index_news target action">
      <div class="index_news_n" >
        <div class="index_news_n_tit">
          <h1>新闻中心 · NEWS</h1>
          <p></p>
        </div>
        <div class="index_news_n_top">
          <dl>
            <dd v-for="(news, index) in topNews" :key="index" @click="goToNewsDetail(news)">
              <a>
                <h3><img :src="news.newImg"></h3>
                <h4>
                  <c>{{ news.newNameCn }}</c>
                </h4>
              </a>
            </dd>
          </dl>
        </div>
        <!-- <div class="index_news_n_lb">
          <div v-for="(news, index) in listNews" :key="index">
            <router-link :to="news.link">
              <p>{{ news.title }}</p>
              <span>&gt;</span>
            </router-link>
          </div>
        </div> -->
        <h2><router-link to="/news">了解更多</router-link></h2>
      </div>
    </div>

    <!-- 加入我们 -->
    <div class="index_apply target action" style="background:url(../images/index_apply_bj.jpg) fixed; background-size:100% 100%;">
      <h1>加入华合半导体「一起领跑芯片新时代」</h1>
      <h2><router-link to="/about">关于我们</router-link></h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      currentIndex: 0,
      autoPlayInterval: null,
      leftHover: false,
      rightHover: false,
      slides: [
        {
          bgImage: require('@/assets/images/1-25112Q03514251.png'),
          title: '领先的芯片技术 引领化合物半导体全产业链发展',
          subtitle: '以卓越的芯片技术的突破与创新，驱动化合物半导体引擎'
        },
        {
          bgImage: require('@/assets/images/1-1ZI1091933311.jpg'),
          title: '行业领先的化合物全产业链业务服务',
          subtitle: '器件设计----器件建模----PDK设计----电路IP设计----芯片流片----整晶圆测试----挑片----微组装'
        },
        {
          bgImage: require('@/assets/images/1-25112Q03524929.jpg'),
          title: '雷达通信功放芯片',
          subtitle: '为先进雷达通信提供强大高效的信号放大能力支撑'
        },
        {
          bgImage: require('@/assets/images/1-25112Q035345B.jpg'),
          title: '卫星通信芯片',
          subtitle: '采用一体的芯片架构设计，可支持星载通信系统的全系列单片产品'
        }
      ],
      services: [
        { icon: require('@/assets/images/1-25011R2333V25.png'), title: '器件模型提取', desc: '高精确的可缩放的器件模型', type: "4" },
        { icon: require('@/assets/images/1-25011R23531626.png'), title: 'PDK开发', desc: '基于ADS-PDK开发', type: "5" },
        { icon: require('@/assets/images/1-25011R255114K.png'), title: 'IP设计服务', desc: '功放芯片/多功能芯片IP设计服务', type: "6" },
        { icon: require('@/assets/images/1-25011R25525138.png'), title: 'IP流片', desc: 'IP流片', type: "7" },
        { icon: require('@/assets/images/1-25011R255405H.png'), title: '整晶圆测试与挑片', desc: '整晶圆测试与挑片', type: "8" },
        { icon: require('@/assets/images/1-25011R2555Qa.png'), title: '芯片微组装', desc: '芯片微组装', type: "9" },
        { icon: require('@/assets/images/1-25011R25616105.png'), title: '货架IP', desc: '自研货架IP(IP\芯片均可出售)', type: "10"  }
      ],
      products: [
        { image: require('@/assets/images/1-25011R25616105.png'), name: '放大器' },
        { image: require('@/assets/images/1-251031212P1121.png'), name: '混频器' },
        { image: require('@/assets/images/1-2511191334141U.jpg'), name: '衰减器' }
      ],
      topNews: [
        { image: require('@/assets/images/1-251222161341Y7.jpg'), title: '南京华合半导体参展2025亚太微波会议：', summary: '韩国，2025年12月2日——在韩国举行的2025亚太微波会议（APMC 202...', link: '/news' },
        { image: require('@/assets/images/1-2511191334141U.jpg'), title: '华合半导体亮相2025雷达无线电产业大会', summary: '2025年11月6日至8日，以"感知无界·智链未来"为主题的2025雷达无线电产...', link: '/news' },
        { image: require('@/assets/images/1-251031212P1121.png'), title: '南京华合半导体亮相2025 IME展会', summary: '2025年10月20日至22日，第十八届中国国际微波及天线技术会（IME 202...', link: '/news' },
         { image: require('@/assets/images/1-251031212P1121.png'), title: '南京华合半导体亮相2025 IME展会', summary: '2025年10月20日至22日，第十八届中国国际微波及天线技术会（IME 202...', link: '/news' },
          { image: require('@/assets/images/1-251031212P1121.png'), title: '南京华合半导体亮相2025 IME展会', summary: '2025年10月20日至22日，第十八届中国国际微波及天线技术会（IME 202...', link: '/news' },
           { image: require('@/assets/images/1-251031212P1121.png'), title: '南京华合半导体亮相2025 IME展会', summary: '2025年10月20日至22日，第十八届中国国际微波及天线技术会（IME 202...', link: '/news' },
            { image: require('@/assets/images/1-251031212P1121.png'), title: '南京华合半导体亮相2025 IME展会', summary: '2025年10月20日至22日，第十八届中国国际微波及天线技术会（IME 202...', link: '/news' }
      ],
      listNews: [
        { title: '南京华合半导体参展2025亚太微波会议：', link: '/news' },
        { title: '华合半导体亮相2025雷达无线电产业大会', link: '/news' },
        { title: '南京华合半导体亮相2025 IME展会', link: '/news' },
        { title: '华合半导体亮相UCMMT2025', link: '/news' },
        { title: '华合半导体精彩亮相第11届世界雷达博览会', link: '/news' },
  
      ]
    }
  },
  metaInfo: {
    title: '南京华合半导体科技有限公司_GaAs/GaN化合物半导体功放芯片_IP设计服务',
    meta: [
      { name: 'description', content: '南京华合半导体科技有限公司专注GaAs/GaN化合物半导体功放芯片研发，提供器件模型提取、PDK开发、IP设计服务、芯片流片、整晶圆测试等全产业链服务。产品应用于雷达通信、5G基站、卫星通信、电子对抗等领域。' },
      { name: 'keywords', content: '南京华合半导体,GaAs功放芯片,GaN功放芯片,化合物半导体,氮化镓芯片,砷化镓芯片,器件模型提取,PDK开发,IP设计服务,射频芯片,功率放大器,5G基站芯片,雷达通信芯片,卫星通信芯片' },
      // 百度收录优化标签
      { name: 'robots', content: 'index,follow' },
      { name: 'author', content: '南京华合半导体科技有限公司' },
      { name: 'copyright', content: '南京华合半导体科技有限公司' },
      { name: 'baidu-site-verification', content: 'codeva-MlwHpJkI5D' },
      // Open Graph 标签
      { property: 'og:title', content: '南京华合半导体科技有限公司 - GaAs/GaN化合物半导体功放芯片' },
      { property: 'og:description', content: '专注GaAs/GaN化合物半导体功放芯片研发，提供器件模型提取、PDK开发、IP设计服务' },
      { property: 'og:url', content: 'https://huaheic.com' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: '南京华合半导体科技有限公司' }
    ],
    link: [
      { rel: 'canonical', href: 'https://huaheic.com' }
    ]
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  created() {
    this.getNewList()
  },
  methods: {
    getNewList() {
      this.$request.get('/wx/news/getListByClassIfy', {"newType": "1", "currentPage": 1, "pageSize": 5}).then(response => {
        this.topNews = response.data.records.slice(0, 3)
      })
    },
    goToNewsDetail(news) {

      if(news.newNameEn){
        window.open(news.newNameEn)
        return 
      }

      this.$router.push({
        path: '/news/detail',
        query: { id: news.id }
      })
    },
    goToSlide(index) {
      this.currentIndex = index
      this.resetAutoPlay()
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.resetAutoPlay()
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.resetAutoPlay()
    },
    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    stopAutoPlay() {
      clearInterval(this.autoPlayInterval)
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    }
  }
}
</script>

<style>
.home {
  height: 100%;
}

/* 淡入动画 */
.target {
  opacity: 0;
  transition: opacity 0.5s ease;
}

.target.action {
  opacity: 1;
}

/* 新闻列表显示所有项 */
.index_news_n_lb div {
  display: block !important;
}

/* 服务介绍 grid 布局 */


/* PC端：覆盖 h5.css 的 400px，使用 100vh */
@media screen and (min-width: 741px) {
    .index_pro.nxa-box {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.index_pro.nxa-box > a,
.index_pro.nxa-box > router-link {
  width: 100%;
  float: none;
}
  .index_banner {
    height: 100vh !important;
  }
  
  .index_banner .flicks .flick-content h1 {
    margin-top: 15%;
  }
  
  .index_banner .flicks .flick-content f {
    margin-bottom: 2%;
  }
  
  /* 新闻摘要显示 */
  .index_news_n_top dl dd h4 b {
    display: block;
    margin-top: 1%;
    color: #A8A8A8;
    font-size: 0.9em;
  }
}

/* 手机端：使用 h5.css 的 400px，但调整文字 */
@media screen and (max-width: 740px) {
  .index_banner .flicks .flick-content h1 {
    margin-top: 20%;
  }
  
  .index_banner .flicks .flick-content h1 c {
    font-size: 16px;
    margin-top: 40px;
  }
  
  .index_banner .flicks .flick-content h1 f {
    font-size: 13px;
    line-height: 1.4;
  }
  
  .index_banner .flicks .flick-content h1 g {
    display: block;
    height: 8px;
  }
}
</style>
